export default {
  homeHeader: {
    lang:'CN',
    keyword:'Please enter a search phrase',
    home : 'Home'
  },
  homeFooter:{
    p1:'Hotline',
    p2:'Official Account',
    p3:'Applet',
    p4:'China Weightlifting Museum All rights reserved Guangdong ICP No. 2024184608-5'
  },
  homeBody:{
    p1:'Opening Time',
    p2:'Enter the hall',
    p3:'Stop Admission',
    p4:'Closing Time',
    p5:'Except for legal holidays, the museum is closed on Mondays, and the system of free booking is implemented',
    p6:'Visit Reservation',
    p7:'Wechat',
    p8:'Email',
    p9:'Individual or group visit booking needs to be made in the wechat mini program',
    p10:'Visitor Guide',
    p11:'Bus',
    p12:'Modern Square Station (357, 352, etc.)',
    p13:'Subway',
    p14:'Take Line 2 to Dongguan Station and transfer to Modern Square Station',
    p15:'Driving',
    p16:'Shilong Town, Dongguan City, people\'s Square',
    p17:'Guided tour service',
    p18:'Audio Guide',
    p19:'Full time guide Chinese free of charge',
    p20:'Paid guided Tours by full-time docents',
    p21:'About Weightlifting Museum',
    p22:'Weightlifting Museum is the only national museum that comprehensively displays the development and brilliant achievements of weightlifting in China, jointly built by the Weightlifting Wrestling and Judo Management Center of the General Administration of Sport of China, the China Weightlifting Association and the Dongguan Municipal People\'s Government. It is located in the famous "Town of weightlifting" - Dongguan Shilong, which has fostered a large number of world-renowned athletes such as Chen Jingkai, who broke the first world record in New China, and Zeng Guoqiang, who won the first Olympic weightlifting gold medal.',
    p23:'Position',
    p24:'Located in Shilong Town, Dongguan City',
    p25:'Floor Area',
    p26:'The total construction area of the venue is more than 14,400 square meters',
    p27:'Collection',
    p28:'Pieces',
    p29:'News Center',
    p30:'More',
    p31:'News',
    p32:'Notice',
    p33:'Dynamic',
  },
  otherPage:{
    p1:'Home',
    p2:'Wechat',
    p3:'Message',
    p4:'E-mail',
    p5:'Can Be Booked',
    p6:'Activity End',
    p7:'See Details',
    p8:'Need Appointment',
    p9:'Detail',
    p10:'Attachment',
    p11:'Share to',
    p12:'Previous Article',
    p13:'Next Article',
    p14:'Nothing',
    p15:'All',
    p16:'Position',
    p17:'Type',
    p18:'Age',
    p19:'Detail',
    p20:'Return',
    p21:'Exhibition Title',
    p22:'Exhibition Time',
    p23:'Location',
    p24:'Exhibition hall appreciation',
    p25:'Ticket Rates',
    p26:'Date',
    p27:'Exhibition Introduction',
    p28:'Picture Appreciation',
    p29:'Special Exhibition Title',
    p30:'Name',
    p31:'Please enter your real name',
    p32:'ID Type',
    p33:'Please select document type',
    p34:'ID Card NO.',
    p35:'Hong Kong Gate Pass',
    p36:'Tai Wan Gate Pass',
    p37:'Passport',
    p38:'Military officer',
    p39:'Soldiers',
    p40:'ID Num',
    p41:'Please enter your ID number',
    p42:'Email',
    p43:'Please enter the email number',
    p44:'Verify',
    p45:'Please enter the verification code',
    p46:'Get Code',
    p47:'Time',
    p48:'Option Date',
    p49:'Confirm',
    p50:'The ticket booking of China Weightlifting Museum has been successful. The admission verification code has been sent to your email address just now. Please bring the valid evidence of your real name registration for verification.',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js